import { createQuery, createSuspenseQuery } from 'react-query-kit';

import {
  CONTENT_CACHE_OPTIONS,
  NON_CRITICAL_CONTENT_QUERY_OPTIONS,
} from '@/api/contentQueryDefaults';
import { getZepetofulCDNContent } from '@/api/zepetoful.api/zepetoful.api';
import { type SelectionSchoolInfo } from '@/views/build/type';

export const ZepetofulSchoolContentQueryOptions = {
  queryKey: ['zepetoful-school-content'],
  variables: {
    entryId: '3trmXRiMwUttqHz9B4gjHr846J74sf',
  },
  fetcher: getZepetofulCDNContent,
};

export const useZepetofulSuspenseSchoolContent = createSuspenseQuery<
  SelectionSchoolInfo,
  { entryId: string }
>({
  ...ZepetofulSchoolContentQueryOptions,
  // suspense 는 로컬 ErrorBoundary(withAsyncBoundary)로 감싸져 있어 캐싱만 강화한다.
  ...CONTENT_CACHE_OPTIONS,
});

export const useZepetofulFetchSchoolContent = createQuery<
  SelectionSchoolInfo,
  { entryId: string }
>({
  ...ZepetofulSchoolContentQueryOptions,
  // 비-suspense 라 전역 throwOnError:true 를 상속하면 500 시 페이지가 죽는다 → 방어.
  ...NON_CRITICAL_CONTENT_QUERY_OPTIONS,
});

export const getZepetofulFetchSchoolContentQueryKey = () => {
  return useZepetofulFetchSchoolContent.getKey({
    ...ZepetofulSchoolContentQueryOptions.variables,
  });
};
